'use strict';

exports.__esModule = true;
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ReactDOMServer = require('react/lib/ReactDOMServer');

var _ReactDOMServer2 = _interopRequireDefault(_ReactDOMServer);

var _serializeJavascript = require('serialize-javascript');

var _serializeJavascript2 = _interopRequireDefault(_serializeJavascript);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Analytics = require('helpers/Analytics');

var _config = require('./../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper component containing HTML metadata and boilerplate tags.
 * Used in server-side code only to wrap the string output of the
 * rendered route component.
 *
 * The only thing this component doesn't (and can't) include is the
 * HTML doctype declaration, which is added to the rendered output
 * by the server.js file.
 */
var Html = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Html, _Component);

  function Html() {
    (0, _classCallCheck3.default)(this, Html);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  Html.prototype.render = function render() {
    var _props = this.props,
        assets = _props.assets,
        component = _props.component,
        store = _props.store;

    var content = component ? _ReactDOMServer2.default.renderToString(component) : '';
    var head = _reactHelmet2.default.rewind();

    return _react2.default.createElement(
      'html',
      { lang: 'en-us' },
      _react2.default.createElement(
        'head',
        null,
        _react2.default.createElement('meta', { charSet: 'utf-8' }),
        _react2.default.createElement('meta', { httpEquiv: 'X-UA-Compatible', content: 'IE=edge' }),
        _react2.default.createElement('meta', { name: 'theme-color', content: '#403788' }),
        _react2.default.createElement('meta', { name: 'msapplication-navbutton-color', content: '#403788' }),
        _react2.default.createElement('meta', { name: 'apple-mobile-web-app-status-bar-style', content: '#403788' }),
        _react2.default.createElement('meta', { name: 'robots', content: 'noindex' }),
        head.base.toComponent(),
        head.title.toComponent(),
        head.meta.toComponent(),
        head.link.toComponent(),
        head.script.toComponent(),
        _react2.default.createElement('link', { rel: 'shortcut icon', href: '/favicon.ico' }),
        _react2.default.createElement('link', { href: '//fonts.googleapis.com/css?family=Open+Sans', rel: 'stylesheet' }),
        _react2.default.createElement('link', { rel: 'stylesheet', href: '//maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css' }),
        _config2.default.env_bf !== 'prod' && _react2.default.createElement('link', { href: '//static.binaryfountain.com/prod/bha-iconfont/style.css', rel: 'stylesheet' }),
        _config2.default.env_bf === 'prod' && _react2.default.createElement('link', { href: '//static.binaryfountain.com/prod/bha-iconfont/style.css', rel: 'stylesheet' }),
        _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1.0, user-scalable=0' }),
        (0, _keys2.default)(assets.styles).map(function (style, key) {
          return _react2.default.createElement('link', { href: assets.styles[style], key: key, media: 'screen, projection, print',
            rel: 'stylesheet', type: 'text/css', charSet: 'UTF-8' });
        }),
        (0, _keys2.default)(assets.styles).length === 0 ? _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: require('../theme/bootstrap.config.js') + require('../containers/App/App.scss')._style } }) : null,
        _react2.default.createElement('script', { charSet: 'UTF-8', dangerouslySetInnerHTML: { __html: 'window.env=' + (0, _serializeJavascript2.default)(_config2.default) + ';' } }),
        _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: 'document.domain = window.env.domain;' } }),
        _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: '\n            window.addEventListener( "message",\n            function (event) {\n              if(event.origin === window.location.origin && event.data == \'logout\'){\n                var logoutForm = document.createElement(\'FORM\');\n                var button = document.createElement(\'input\');\n                button.setAttribute(\'type\', \'submit\');\n                logoutForm.name = \'logout\';\n                logoutForm.method = \'POST\';\n                logoutForm.action = \'/app/logout\';\n                logoutForm.appendChild(button);\n                document.body.appendChild(logoutForm);\n                logoutForm.submit();\n              }\n            },\n            false);\n            if (window.env === \'production\') {\n              window.onerror = function(msg, url, line, col, error) {\n                 // Log information\n                 console.error("Error: " + msg + " - url: " + url + " - line: " + line + " - col: " + col + " - error: " + error);\n\n                 // TODO: Report this error via ajax so can keep track of what pages have JS issues\n\n                 var suppressErrorAlert = true;\n                 // If return true, then error alerts (like in older versions of  Internet Explorer) will be suppressed.\n                 return suppressErrorAlert;\n              };\n            }\n            if (\'onhashchange\' in window) {\n              window.onhashchange = function() {\n                if (location.hash.indexOf(\'mentions\') !== -1 && location.hash.indexOf(\'dateRange\') !== -1 && location.hash.indexOf(\'inputDateTimeZone=UTC\') !== -1) {\n                  document.body.remove();\n                  window.location.href = location.hash.replace(\'inputDateTimeZone=UTC\', \'\');\n                  window.location.reload(true);\n                }\n              }\n            }\n          ' } })
      ),
      _react2.default.createElement(
        'body',
        null,
        _react2.default.createElement('div', { id: 'content', dangerouslySetInnerHTML: { __html: content } }),
        _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: 'window.__data=' + (0, _serializeJavascript2.default)(store.getState()) + ';' }, charSet: 'UTF-8' }),
        _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: _Analytics.googleAnalyticsCode }, charSet: 'UTF-8' }),
        _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: 'window.env=' + (0, _serializeJavascript2.default)(_config2.default) + ';' }, charSet: 'UTF-8' }),
        _react2.default.createElement('script', { src: assets.javascript.vendors, charSet: 'UTF-8' }),
        _react2.default.createElement('script', { src: assets.javascript.main, charSet: 'UTF-8' }),
        _react2.default.createElement(
          'noscript',
          null,
          _react2.default.createElement(
            'div',
            { style: { 'margin': '20px', 'text-align': 'center' } },
            _react2.default.createElement(
              'h1',
              null,
              'Javascript disabled'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Sorry, our application needs Javascript in order to work. Please enable Javascript and reload this page.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Here are the ',
              _react2.default.createElement(
                'a',
                { href: 'https://www.enable-javascript.com/', target: '_blank' },
                'instructions how to enable JavaScript in your web browser'
              ),
              '.'
            )
          )
        )
      )
    );
  };

  return Html;
}(_react.Component), _class.propTypes = {
  assets: _react.PropTypes.object,
  component: _react.PropTypes.node,
  store: _react.PropTypes.object
}, _temp);
exports.default = Html;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Html.js
// module id = 2420
// module chunks = 0